import React from 'react';
import { Row, Col } from 'antd';
import { NavLink } from 'react-router-dom';

import { personTimetable, trainerTimetable } from 'constants/routes';

const EducationEventDescription = ({ event, event: { name, place, project = {} }, openModalEducationEvent }) => (
    <div className="calendar-event-main-information">
        <a onClick={() => openModalEducationEvent(event)}>
            <div className="calendar-event-name">
                {name}
            </div>
        </a>
        { place &&
            <Row className="calendar-comment m-b-15">
                <Col xs={20} sm={12} className="text-pre-space">
                    {place}
                </Col>
            </Row>
        }
        { project.name &&
            <Row className="calendar-comment m-b-15">
                <Col xs={20} sm={12} className="text-pre-space">
                    <NavLink to={(event.key ? trainerTimetable : personTimetable).stringify({ project: project.id })}>
                        {project.name}
                    </NavLink>
                </Col>
            </Row>
        }
    </div>
);

export default EducationEventDescription;
